import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiDownload } from 'react-icons/fi';

// Using an anchor tag for direct store protocol handling
const MicrosoftStoreBtn = ({ accentColor = 'bg-accent-red', className = '', href = '#' }) => {
  return (
    <a 
      href={href}
      className={`btn-primary ${accentColor} text-white ${className} decoration-transparent`}
      target={href.startsWith('http') ? '_blank' : '_self'}
      rel="noopener noreferrer"
    >
      <SafeIcon icon={FiDownload} className="w-5 h-5" />
      <div className="flex flex-col items-start leading-none">
        <span className="text-[10px] uppercase tracking-wider opacity-80">Available on</span>
        <span className="text-sm font-semibold">Microsoft Store</span>
      </div>
    </a>
  );
};

export default MicrosoftStoreBtn;